import { html } from 'lit';
// eslint-disable-next-line import/extensions
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { PageDetails } from '@mfe/types/common';
// eslint-disable-next-line import/no-cycle
import TefComs from '../../tef-coms';

export const pageFooter = (tefComs: TefComs) => html`
  <one-text as="p">
  ${unsafeHTML((tefComs.details as PageDetails).pageFooter)}
  </one-text>`;

export default pageFooter;
